var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.next)?_c('mj-button',{staticClass:"btn-primary",on:{"click":_vm.loadMore}},[_vm._v(" mehr anzeigen ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }